/**
 * @generated SignedSource<<bdf4bfb25069a9dd27ff445a8904bce4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteFinderPage_sheet$data = {
  readonly id: string;
  readonly thumbnail_download_url: string;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPageOverlay_sheet" | "NoteFinderPageTools_sheet">;
  readonly " $fragmentType": "NoteFinderPage_sheet";
};
export type NoteFinderPage_sheet$key = {
  readonly " $data"?: NoteFinderPage_sheet$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteFinderPage_sheet">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteFinderPage_sheet",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnail_download_url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteFinderPageOverlay_sheet"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NoteFinderPageTools_sheet"
    }
  ],
  "type": "MusicSheet",
  "abstractKey": null
};

(node as any).hash = "8dc1aa4224374f7f346af9c141aa6423";

export default node;
